import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output
} from '@angular/core'
import { filter } from 'rxjs/operators'
import { SportDataSummary } from '../../../shared/sport-data/types'

interface StreamTileEventInfo {
  id?: string
  title?: string
}

export interface TileSelectedEvent {
  stream: StreamTileEventInfo
  element: HTMLElement
}

@Component({
  selector: 'flo-stream-tile',
  templateUrl: './stream-tile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StreamTileComponent {
  constructor(private elementRef: ElementRef) {}

  @Input()
  get eventAnalytics(): any {
    return {
      ...this._eventAnalytics
    }
  }

  set eventAnalytics(val: any) {
    this._eventAnalytics = val
  }

  @HostBinding('class.is-playing')
  get isPlayingClassBinding() {
    return this.isPlaying
  }

  get view() {
    return {
      streamThumbnail: this.canShowSnapImg() ? this.streamThumbnail : undefined,
      canShowSnapshot: this.canShowSnapImg(),
      title: this.title(),
      subtitle: this.subtitle(),
      canAdd: this.canAdd,
      canRemove: this.canRemove,
      darken: this.canRemove,
      isPlaying: this.isPlaying,
      analyticProps: {
        ...this.eventAnalytics,
        stream_title: this.title(),
        stream_id: this.streamId,
        name: 'Stream Tile'
      }
    }
  }
  private _eventAnalytics: any
  @Input()
  streamId?: string
  @Input()
  streamName?: string
  @Input()
  streamAlias?: string
  @Input()
  streamThumbnail?: string
  @Input()
  canAdd: boolean
  @Input()
  canRemove: boolean
  @Input()
  canPlay: boolean
  @Input()
  canShowSnapshot: boolean
  @Input()
  isPlaying: boolean
  @Input()
  sportData: SportDataSummary | undefined
  @Input()
  eventHasSportData: boolean

  @Output()
  readonly tileClick = new EventEmitter<TileSelectedEvent>()
  @Output()
  readonly tileAddClick = this.tileClick.pipe(filter(() => this.canAdd))
  @Output()
  readonly tileRemoveClick = this.tileClick.pipe(filter(() => this.canRemove))

  @HostListener('click')
  tileClickedListener = () =>
    this.tileClick.next({
      stream: this.eventData(),
      element: this.elementRef.nativeElement
    })

  canShowSnapImg() {
    return this.canShowSnapshot && this.canPlay && (this.streamThumbnail ? true : false)
  }

  title() {
    return this.streamAlias || this.streamName
  }

  subtitle() {
    return this.streamAlias && this.streamName
  }

  eventData() {
    return {
      id: this.streamId,
      title: this.title(),
      ...this.eventAnalytics
    }
  }
}
